<template>
  <div class="base-from-to-scale">
    <vue-slider v-model="value"
                :data="sliderValues"
                :marks="true"
                :included="true"
                tooltip="none"
                :process="true"
                :disabled="disabled"
                :height="8"
                :dotSize="24"
                :style="disabled ? disabledColor : activeColor">

      <template v-slot:mark="{ label }">
        <div class="mark"
             :style="selected === label ? `transform: translateY(-50%); ${markColor}` : ''">
          {{ label }}
        </div>
      </template>

      <template v-slot:dot>
        <img src="./images/icon-check.png" class="custom-dot"/>
      </template>

    </vue-slider>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'

export default {
  components: { VueSlider },
  props: {
    disabled: {
      type: Boolean
    },
    rangeOfNumbers: {
      type: Array,
      required: false
    },
    selected: {
      type: Number
    }
  },
  data () {
    return {
      value: 0,
      sliderValues: [],
      activeColor: { '--process-color': '#ed1a3b' },
      disabledColor: { '--process-color': '#cecece' }
    }
  },
  mounted () {
    this.value = this.selected
    this.sliderValues = [...this.rangeOfNumbers]
  },
  computed: {
    markColor () {
      if (!this.disabled) return 'color: #ed1a3b'
      else return ''
    }
  },
  watch: {
    selected (newValue) {
      if (newValue) {
        this.value = newValue
      }
    },
    value () {
      this.$emit('selectedNumber', this.value)
    }
  }
}
</script>

<style lang="scss">
.base-from-to-scale {
  .vue-slider {

    &-process {
      background: var(--process-color);
    }

    &-marks {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      transform: translateY(-325%);

      width: 103.5%;
      margin-left: -1.5%;

      .mark {
        font-size: 12px;
        font-weight: 600;
        color: #999;
        background-color: transparent;
        transition: all ease-in 0.2s;
      }
    }

    &-process {
      border-radius: 10px;
    }

    &-dot {
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1;
    }
  }
}
</style>
